import { ConsentUIFlow } from "healthex-common/consent.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { i18nSetLanguage } from "../Infra/i18next";
import { patientConsentStepParentId } from "./PatientConsentManagerShared.styles";
import { getUIHash } from "./uiHash";
import { plainToInstance } from "class-transformer";
import { DocumentRetrievalTaskBatchDto } from "healthex-common/document.retrieval.dtos";
export class ScreenshotAPI {
    constructor(authManager, patientConsentUIManager) {
        this.authManager = authManager;
        this.patientConsentUIManager = patientConsentUIManager;
        ;
        window.hxScreenshotAPI = this;
    }
    async login(generateTokenResult) {
        await this.authManager.authenticateScreenshotUser(generateTokenResult);
    }
    async getConsentFlowUrls(input) {
        var _a, _b;
        if (input.consentUIFlow === ConsentUIFlow.PATIENT_DIRECTED_DATA_EXCHANGE) {
            if (input.consentFlowPageData) {
                this.patientConsentUIManager.updateConsentFlowPageData(input.consentFlowPageData);
            }
            const baseValues = {
                fullPage: true,
                width: 500,
                waitForSelector: `#${patientConsentStepParentId}`,
            };
            return (await this.patientConsentUIManager.getConsentFlowUrls(input.studyId, input.studyVersionId, (_b = (_a = input.consentFlowPageData) === null || _a === void 0 ? void 0 : _a.previewMetadata) !== null && _b !== void 0 ? _b : undefined, input.pagesViewed)).map((url) => ({
                ...baseValues,
                ...url,
            }));
        }
        else {
            return willNeverHappen(input.consentUIFlow);
        }
    }
    async setConsentFlowPageData(input) {
        if (input.retrieval) {
            input.retrieval = plainToInstance(DocumentRetrievalTaskBatchDto, input.retrieval);
        }
        if (input.language) {
            console.log(`Setting language in screenshot API: ${input.language}`);
            await i18nSetLanguage(input.language);
        }
        if (input.consentUIFlow === ConsentUIFlow.PATIENT_DIRECTED_DATA_EXCHANGE) {
            if (input.isPreview) {
                input.documentRetrievalLocations = this.patientConsentUIManager.previewMockedLocationData;
            }
            this.patientConsentUIManager.updateConsentFlowPageData(input);
        }
        else {
            willNeverHappen(input.consentUIFlow);
        }
    }
    getUIHash() {
        return getUIHash();
    }
}
